<template>
    <div class="abschluss-fehler-box px-4 py-5 p-md-5 d-flex flex-column justify-content-center align-items-center">
        <grosser_fehler></grosser_fehler>
        <div class="mt-5 mb-4">
            <b>Die Daten konnten nicht verifiziert werden.</b>
        </div>

        <div class="abschluss-fehler-info-box px-4 py-3 px-md-5 py-md-4">
            <b>Kontaktieren Sie uns bitte telefonisch unter 0211 355900-0.</b><br>
            {{ anzeigeFehlermeldung }}
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import grosser_fehler from './icons/grosser_fehler_icon.vue';

const props = defineProps({
    fehlermeldung: {
        type: String,
        default: ''
    }
});

// Fallback auf Standardmeldung wenn keine Fehlermeldung übergeben wurde
const anzeigeFehlermeldung = computed(() => {
    return props.fehlermeldung || 'Aufgetretender Fehlercode: Daten bereits verifiziert';
});
</script>